<template>
  <div class="row mt-10">
    <div
      id="kt_profile_aside"
      class="col-xxl-4 col mb-5 w-sm-100 w-300px w-xl-350px"
    >
      <!-- offcanvas-mobile -->
      <div class="card card-custom card-stretch">
        <div class="card-body pt-4">
          <div class="d-flex justify-content-end"></div>
          <div class="d-flex align-items-center">
            <div
              class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center"
            >
              <div
                :style="{ backgroundImage: `url(${userImage})` }"
                class="symbol-label"
              ></div>
              <i class="symbol-badge bg-success"></i>
            </div>
            <div>
              <a
                class="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary"
              >
                {{ user.name }} {{ user.lastName }}
              </a>
              <div class="text-muted">{{ user.type | userType }}</div>
              <div class="mt-2"></div>
            </div>
          </div>
          <!-- end::User -->
          <!-- begin::Contact -->
          <div class="py-9">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2"
                >{{ $t("customPage.email") }}:</span
              >
              <a class="text-muted text-hover-primary">
                {{ user.email }}
              </a>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2"
                >{{ $t("customPage.balance") }}:</span
              >
              <span class="text-muted"
                >{{ persian($options.filters.rial(wallet.balance)) }}
                {{ $t("customPage.rial") }}</span
              >
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2"
                >{{ $t("customPage.phone") }}:</span
              >
              <span class="text-muted">{{ persian(user.phone) }}</span>
            </div>
          </div>
          <!-- end::Contact -->
          <!-- begin::Nav -->
          <div class="v-application v-application--is-rtl" data-app="true">
            <div
              class="v-application--wrap"
              style="min-height: 350px !important"
            >
              <div
                class="navi navi-bold navi-hover navi-active navi-link-rounded"
                role="tablist"
              >
                <div class="navi-item mb-2">
                  <a
                    aria-selected="false"
                    class="navi-link py-4 active"
                    data-tab="0"
                    data-toggle="tab"
                    role="tab"
                    style="cursor: pointer"
                    @click="setActiveTab"
                  >
                    <span class="navi-icon mr-2">
                      <span class="svg-icon">
                        <inline-svg
                          fill="#569842"
                          src="media/svg/icons/Design/Layers.svg"
                        />
                      </span>
                    </span>
                    <span class="navi-text font-size-lg">{{
                      $t("customPage.overview")
                    }}</span>
                  </a>
                </div>
                <div class="navi-item mb-2">
                  <a
                    aria-selected="false"
                    class="navi-link py-4"
                    data-tab="1"
                    data-toggle="tab"
                    role="tab"
                    style="cursor: pointer"
                    @click="setActiveTab"
                  >
                    <span class="navi-icon mr-2">
                      <span class="svg-icon">
                        <inline-svg src="media/svg/icons/General/User.svg" />
                      </span>
                    </span>
                    <span class="navi-text font-size-lg">{{
                      $t("customPage.personalInfo")
                    }}</span>
                  </a>
                </div>
                <div class="navi-item mb-2">
                  <a
                    aria-selected="false"
                    class="navi-link py-4"
                    data-tab="4"
                    data-toggle="tab"
                    role="tab"
                    style="cursor: pointer"
                    @click="setActiveTab"
                  >
                    <span class="navi-icon mr-2">
                      <span class="svg-icon">
                        <inline-svg
                          src="media/svg/icons/Communication/Mail-opened.svg"
                        />
                      </span>
                    </span>
                    <span class="navi-text font-size-lg">{{
                      $t("customPage.completeProfile")
                    }}</span>
                  </a>
                </div>
                <div class="navi-item mb-2">
                  <a
                    aria-selected="false"
                    class="navi-link py-4"
                    data-tab="3"
                    data-toggle="tab"
                    role="tab"
                    style="cursor: pointer"
                    @click="setActiveTab"
                  >
                    <span class="navi-icon mr-2">
                      <span class="svg-icon">
                        <inline-svg
                          src="media/svg/icons/Communication/Shield-user.svg"
                        />
                      </span>
                    </span>
                    <span class="navi-text font-size-lg">{{
                      $t("customPage.changePassword")
                    }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- begin::Content -->
    <div class="col-xxl-8 w-100 flex-row-fluid">
      <b-tabs v-model="tabIndex" class="hide-tabs">
        <b-tab active>
          <KTProfileOverview></KTProfileOverview>
        </b-tab>
        <b-tab>
          <KTPersonalInformation></KTPersonalInformation>
        </b-tab>
        <b-tab>
          <KTAccountInformation></KTAccountInformation>
        </b-tab>
        <b-tab>
          <KTChangePassword></KTChangePassword>
        </b-tab>
        <b-tab>
          <KTEmailSettings></KTEmailSettings>
        </b-tab>
      </b-tabs>
    </div>
    <!-- end::Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTDropdown2 from "@/view/content/dropdown/Dropdown2";
import KTProfileOverview from "@/view/pages/profile/profile-comp-1/ProfileOverview";
import KTPersonalInformation from "@/view/pages/profile/profile-comp/PersonalInformation";
import KTAccountInformation from "@/view/pages/profile/profile-comp/AccountInformation";
import KTChangePassword from "@/view/pages/profile/profile-comp/ChangePassword";
import KTEmailSettings from "@/view/pages/profile/profile-comp/EmailSettings";
import i18n from "@/i18n";

export default {
  name: "custom-page",
  i18n,
  components: {
    KTDropdown2,
    KTProfileOverview,
    KTPersonalInformation,
    KTAccountInformation,
    KTChangePassword,
    KTEmailSettings,
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$route.meta.title }]);
  },
  methods: {
    getNewWallet() {
      this.loading = true;
      this.requestApiPostWallet("wallet")
        .then(({ data }) => {
          if (data.data.balance >= 0) {
            this.balance =
              data.data.balance !== null
                ? this.persianNum(
                    this.currency(Math.floor(data.data.balance.toString()))
                  )
                : this.$t("customPage.notCreated");
          } else {
            this.balance =
              data.data.balance.$numberDecimal !== undefined
                ? this.persianNum(
                    this.currency(
                      Math.floor(data.data.balance.$numberDecimal.toString())
                    )
                  )
                : this.$t("customPage.notCreated");
          }
        })
        .catch(({ response }) => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    },
    setActiveTab(event) {
      let target = event.target;
      if (!event.target.classList.contains("navi-link")) {
        target = event.target.closest(".navi-link");
      }

      const tab = target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".navi-link");
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.tabIndex = parseInt(target.getAttribute("data-tab"));
      target.classList.add("active");
    },
  },
  computed: {
    ...mapGetters("ribbon", ["new_wallet"]),
    wallet: {
      get() {
        return this.new_wallet;
      },
      set(val) {},
    },
    userImage() {
      return this.user &&
        this.user?.image !== null &&
        this.user?.image !== undefined
        ? `"${this.$coreApi}/storage/"` + this.user.image
        : "/media/user_avatar.jpeg";
    },
    ...mapGetters(["currentUserPersonalInfo"]),
    getFullName() {
      return (
        this.currentUserPersonalInfo.name +
        " " +
        this.currentUserPersonalInfo.surname
      );
    },
  },
};
</script>

<style>
#kt_footer {
  bottom: 0 !important;
}
</style>
<style scoped>
svg[data-v-8d2b108a] path {
  fill: #1c0152 !important;
}
</style>
